import {VersionVariants} from '@jobseeker/lotus/enums';
import {Box, Link, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import Dialog from '../Dialog';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {useState} from 'react';
import dynamic from 'next/dynamic';

const BottomSheet = dynamic(
  () => import('@jobseeker/lotus/elements/BottomSheet'),
  {ssr: false}
);

interface PartnerCardDataType {
  key: number;
  companyLogo: string;
  jobTitle: string;
  jobLocation: string;
  link: string;
  description: string;
}

const styles = {
  partnerCard: {
    minWidth: 360,
    height: 170,
    margin: 2,
    padding: 2,
    borderRadius: 2.5,
    backgroundColor: '#ededf4',
    textAlign: 'center',
  },
  jobTitle: {
    fontSize: '18px',
    fontWeight: 500,
    textAlign: 'center',
    color: '#000',
  },
  jobLocation: {
    width: '100%',
    textAlign: 'center',
    color: '#333',
    marginTop: 0.5,
  },
  knowMore: {
    margin: '0 auto',
    fontSize: '14px',
    fontWeight: 500,
    textAlign: 'center',
    color: 'primary.main',
    cursor: 'pointer',
    marginTop: 0.5,
  },
};

const DialogComponent = ({
  open = false,
  handleClose,
  description,
}: {
  handleClose: () => void;
  open: boolean;
  description: string;
}) => {
  const isLarge = useIsLargeDevice();
  const WrapperComponent = isLarge ? Dialog : BottomSheet;

  return (
    <WrapperComponent
      title="Details"
      subtitle={''}
      variant={VersionVariants.VERSION_TWO}
      open={open}
      maxWidth={'lg'}
      onClose={handleClose}
      onDismiss={handleClose}
      bannerMode={true}
      maxHeight={422}
    >
      <Box
        sx={{
          padding: {xxs: 2, md: 1},
        }}
        height={'auto'}
        width={{xss: '100%', md: 534}}
        data-testid="resume-banner-popup"
      >
        <Box height={'100%'} display={'flex'} width={'100%'}>
          <Box width={'100%'}>
            <Box mb={1}>
              <Typography
                component="div"
                sx={{whiteSpace: 'pre-line'}}
                dangerouslySetInnerHTML={{__html: description}}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </WrapperComponent>
  );
};
const PartnerCard = ({
  key,
  companyLogo,
  jobTitle,
  jobLocation,
  description,
}: PartnerCardDataType) => {
  const [open, setOpen] = useState(false);
  const handleClickPopUp = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={styles.partnerCard} key={key}>
      <Image src={companyLogo} alt="Company Logo" width={104} height={50} />
      <Typography sx={styles.jobTitle}>{jobTitle}</Typography>
      <Box sx={styles.jobLocation}>{jobLocation}</Box>
      <Link sx={styles.knowMore} onClick={handleClickPopUp}>
        Know More
      </Link>
      <DialogComponent
        handleClose={handleClose}
        open={open}
        description={description}
      />
    </Box>
  );
};

export default PartnerCard;
